import * as bootstrap from 'bootstrap';
import naja from 'naja';

class AjaxModal {
	#ajaxModal;
	#bootstrap;
	#naja;
	#formHasUnsavedChanges = false;
	#isFormSubmitting = false;

	constructor() {
		this.#bootstrap = bootstrap;
		this.#naja = naja;
	}

	init() {
		// Počkej na DOM pokud není připravený
		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', () => {
				this.#initializeWithDOM();
			});
		} else {
			this.#initializeWithDOM();
		}
	}

	#initializeWithDOM() {
		this.#ajaxModal = document.getElementById('ajax-modal');

		if (!this.#ajaxModal) {
			console.error('Modal element with ID "ajax-modal" not found.');
			return;
		}

		this.#formHasUnsavedChanges = false;
		this.#isFormSubmitting = false;
		this.#addEventListeners();
	}

	#addEventListeners() {
		this.#ajaxModal.addEventListener('hide.bs.modal', (event) => {
			this.#checkHidingModal(event);
		});

		this.#ajaxModal.addEventListener('hidden.bs.modal', () => {
			this.#clearModal()
		});

		this.#ajaxModal.addEventListener('show.bs.modal', (event) => {
			this.#setupModal(event);
		});

		this.#ajaxModal.addEventListener('input', () => {
			this.#formHasUnsavedChanges = true;
		});

		this.#ajaxModal.addEventListener('submit', () => {
			this.#isFormSubmitting = true;
		});

		this.#naja.addEventListener('payload', (event) => {
			if (event.detail.payload.resetFormChanges) {
				this.#formHasUnsavedChanges = false;
			}

			if (event.detail.payload.closeModal) {
				const modalInstance = this.#bootstrap.Modal.getInstance(this.#ajaxModal);
				if (modalInstance) {
					modalInstance.hide();
				}
			}
		});

		// Naslouchání úspěšnému dokončení AJAX požadavku
		this.#naja.addEventListener('complete', () => {
			this.#isFormSubmitting = false;
		});
	}

	#checkHidingModal(event) {
		document.querySelectorAll(':focus').forEach(element => element.blur());
		if (this.#isFormSubmitting) {
			return;
		}

		if (this.#modalHasUnsavedChanges()) {
			const confirmClose = confirm(
				"V okně jsou neuložené změny. Opravdu si přejete ho zavřít?"
			);

			if (!confirmClose) {
				event.preventDefault(); // Zablokuj zavření modálu
			}
		}
	}

	#modalHasUnsavedChanges() {
		let modalHasUnsavedChanges = false;
		if (typeof window.tinymce !== 'undefined') {
			if (window.tinymce.activeEditor?.isDirty()) {
				modalHasUnsavedChanges = true;
			}
		}
		if (this.#formHasUnsavedChanges === true) {
			modalHasUnsavedChanges = true;
		}
		return modalHasUnsavedChanges;
	}

	#setupModal(event) {
		this.#clearModal();
		const modalDialog = this.#ajaxModal.querySelector('.modal-dialog');
		const modalTitle = this.#ajaxModal.querySelector('.modal-title');

		if (modalTitle) {
			modalTitle.innerHTML = 'Načítám… <i class="fas fa-spinner fa-spin"></i>';
		}

		const modalSize = event.relatedTarget.dataset.bsModalSize;
		if (modalSize && modalDialog) {
			modalDialog.classList.add(`modal-${modalSize}`);
		}
	}

	#clearModal() {
		this.#formHasUnsavedChanges = false;
		this.#isFormSubmitting = false;
		this.#ajaxModal.querySelectorAll('.modal-title, .modal-subtitle, .modal-body').forEach(element => element.innerHTML = '');
	}
}

export default new AjaxModal();